import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

export async function verifyEmailCode(email: string, verificationCode: string) {
    try {
        const payload = { email, verification_code: verificationCode };

        const { status } = await axios.post(Endpoints.User.Email, payload);

        return status === 200;
    } catch (error) {
        return false;
    }
}
